import { WithOwner } from "../IDBSchema";
import { EntityDataApi } from "../IndexedDBApi";
import { ConstructionRecordBase, ConstructionRecordBasePatchPayload, ConstructionRecordBasePutPayload } from "../../../schema/generated/ConstructionRecord";
import { getFromIdPayload, setDeletePayload } from "../../../schema/general";
import { PutStatusResponse, StatusResponse } from "../../../schema/console/statusData";
import { ConstructionRecordForMaterialSearch } from "../../../schema/console/material";
import { constructionRecordWithUser } from "../../../schema/console/construction_records";
import { idbEntityDefs } from "../generated/entityDefs";
import { required } from "../../../util/typed";

export class ConstructionRecordDataApi extends EntityDataApi<ConstructionRecordBase> {
  public readonly def = idbEntityDefs.ConstructionRecord;

  public async getAll(ownerId: string): Promise<ConstructionRecordBase[]> {
    return await this.listByOwner(ownerId);
  }

  public async getById(payload: WithOwner<getFromIdPayload>): Promise<ConstructionRecordBase | null> {
    return await this.findById(payload);
  }

  public async getByConstructionIdForMaterialSearch(payload: WithOwner<getFromIdPayload>): Promise<ConstructionRecordForMaterialSearch> {
    const data = await this.readByIndex("construction_id", payload.ownerId, payload.id);
    const userIds = [...new Set(data.map((c) => c.preparer_user_id))];
    const users = await Promise.all(
      userIds.map((id) =>
        this.IDB().userDataApi.getFullDataById({ id, ownerId: payload.ownerId })
      )
    );
    const userMap = new Map(users.map((u) => [u.id, u]));
    return data.map((d) => ({ ...d, User: required(userMap.get(d.preparer_user_id), "登録者ユーザー") }));
  }

  public async getByConstructionId(payload: WithOwner<getFromIdPayload>): Promise<constructionRecordWithUser[]> {
    const data = await this.readByIndex("construction_id", payload.ownerId, payload.id);
    const userIds = [...new Set(data.map((c) => c.preparer_user_id))];
    const users = await Promise.all(
      userIds.map((id) =>
        this.IDB().userDataApi.getFullDataById({ id, ownerId: payload.ownerId })
      )
    );
    const userMap = new Map(users.map((u) => [u.id, u]));
    return data.map((d) => ({ ...d, User: required(userMap.get(d.preparer_user_id), "登録者ユーザー") }));
  }

  public async put(data: WithOwner<ConstructionRecordBasePutPayload>): Promise<PutStatusResponse> {
    return await this.createRow(data);
  }

  public async patch(data: WithOwner<ConstructionRecordBasePatchPayload>): Promise<StatusResponse> {
    return await this.patchRow(data);
  }

  public async delete(data: WithOwner<setDeletePayload>): Promise<StatusResponse> {
    return await this.softDelete(data);
  }
}
